import React from "react";

function ChatIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      fill="none"
      viewBox="0 0 19 18"
    >
      <path
        fill="#fff"
        d="M5.478 5.25h7.5v1.5h-7.5v-1.5zm0 3h5.25v1.5h-5.25v-1.5z"
      ></path>
      <path
        fill="#fff"
        d="M15.228 1.5h-12c-.827 0-1.5.673-1.5 1.5v13.5l4-3h9.5c.827 0 1.5-.673 1.5-1.5V3c0-.827-.673-1.5-1.5-1.5zm0 10.5h-10l-2 1.5V3h12v9z"
      ></path>
    </svg>
  );
}

export default ChatIcon;
